import { Link, useLocation } from "react-router-dom";
import { 
  LayoutDashboard, Calendar, Users, BookOpen, Trophy, Film, 
  MessageSquare, Bell, Globe, TrendingUp, Ticket, Newspaper, UserCheck,
  ShoppingBag, BarChart3, Target, BookHeart, HelpCircle, Clock, Music, Image, ArrowLeftRight, Search
} from "lucide-react";

const AdminSidebar = () => {
  const location = useLocation();
  
  const navItems = [
    { path: "/admin", icon: LayoutDashboard, label: "Dashboard" },
    { path: "/admin/analytics", icon: TrendingUp, label: "Analytics" },
    { path: "/admin/notifications", icon: Bell, label: "Notifications" },
    { path: "/admin/discount-codes", icon: Ticket, label: "Discount Codes" },
    { path: "/admin/fixtures", icon: Calendar, label: "Fixtures" },
    { path: "/admin/tables", icon: BarChart3, label: "Tables" },
    { path: "/admin/stats", icon: Target, label: "Stats" },
    { path: "/admin/players", icon: Users, label: "Players" },
    { path: "/admin/history", icon: BookOpen, label: "History" },
    { path: "/admin/cups", icon: Trophy, label: "Cups" },
    { path: "/admin/entertainment", icon: Film, label: "Entertainment" },
    { path: "/admin/fan-clubs", icon: Globe, label: "Fan Clubs" },
    { path: "/admin/fan-memories", icon: BookHeart, label: "Fan Memories" },
    { path: "/admin/shop", icon: ShoppingBag, label: "Shop" },
    { path: "/admin/news", icon: Newspaper, label: "News" },
    { path: "/admin/forum", icon: MessageSquare, label: "Forum" },
    { path: "/admin/faqs", icon: HelpCircle, label: "FAQs" },
    { path: "/admin/on-this-day", icon: Clock, label: "On This Day" },
    { path: "/admin/chants", icon: Music, label: "Chants" },
    { path: "/admin/memes", icon: Image, label: "Memes" },
    { path: "/admin/transfers", icon: ArrowLeftRight, label: "Transfers" },
    { path: "/admin/seo-health", icon: Search, label: "SEO Health" },
    { path: "/admin/users", icon: UserCheck, label: "Users" },
  ];

  return (
    <div className="w-64 bg-[#0F172A] min-h-screen p-4" data-testid="admin-sidebar">
      <div className="mb-8">
        <h2 className="text-white text-xl font-bold" style={{ fontFamily: 'Barlow Condensed' }}>
          ADMIN PANEL
        </h2>
        <p className="text-slate-400 text-sm">All WHUFC</p>
      </div>
      
      <nav className="space-y-1">
        {navItems.map(item => {
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                isActive 
                  ? "bg-[#7C2C3B] text-white" 
                  : "text-slate-400 hover:bg-slate-800 hover:text-white"
              }`}
            >
              <item.icon className="w-5 h-5" />
              <span className="text-sm font-medium">{item.label}</span>
            </Link>
          );
        })}
      </nav>
    </div>
  );
};

export default AdminSidebar;
